const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID
const FORCE_GA = import.meta.env.VITE_ENABLE_DEV_GA === 'true'

let initialized = false

function isLocalDev() {
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0'
}

/**
 * Google Analytics 4 (gtag.js) bootstrap.
 *
 * Equivalent to the GA "Google tag" snippet, but loaded from JS so the
 * measurement ID comes from env and nothing fires on localhost unless
 * VITE_ENABLE_DEV_GA=true. GA4 Enhanced Measurement tracks SPA route changes
 * (history pushState) automatically, so no router hook is needed.
 */
export function initGoogleAnalytics() {
  if (initialized || !GA_MEASUREMENT_ID) return
  if (isLocalDev() && !FORCE_GA) {
    console.log('Google Analytics disabled on localhost (set VITE_ENABLE_DEV_GA=true to override)')
    return
  }
  initialized = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag

  gtag('js', new Date())
  gtag('config', GA_MEASUREMENT_ID, { debug_mode: FORCE_GA })
}

/** Send a custom GA4 event. No-op when GA is not initialized. */
export function trackGaEvent(name, params = {}) {
  if (!initialized || typeof window.gtag !== 'function' || !name) return
  window.gtag('event', name, params)
}
